import React, { useState } from 'react';
import { Archive, Cpu, DatabaseZap, Plus } from 'lucide-react';
import PillTabs from '../../../../components/common/PillTabs';
import { useTheme } from '../../../../components/common/Theme';
import { primaryBtn } from '../../governed-mcp-gateway/components/GatewayUi';
import DataStores from '../DataStores';
import Cache from './Cache';
import DataVaults from './DataVaults';

type TabId = 'vector-store' | 'cache' | 'data-vault';

const TABS = [
  { id: 'vector-store' as const, label: 'Vector Store', icon: DatabaseZap },
  { id: 'cache' as const, label: 'Cache', icon: Cpu },
  { id: 'data-vault' as const, label: 'Data Vault', icon: Archive },
];

const ADD_LABEL: Record<TabId, string> = {
  'vector-store': 'Add New Datastore',
  cache: 'Add Redis Config',
  'data-vault': 'Add New Vault',
};

const DataVaultRouting: React.FC = () => {
  const { theme } = useTheme();
  const isLight = theme === 'white';
  const [tab, setTab] = useState<TabId>('vector-store');
  const [addTick, setAddTick] = useState(0);

  return (
    <div className={`w-full min-w-0 -m-3 min-h-[calc(100vh-1.5rem)] ${isLight ? 'bg-slate-50' : 'bg-neutral-950'}`}>
      <header className={`px-6 pt-6 ${isLight ? 'bg-slate-50' : 'bg-neutral-950'}`}>
        <p className={`m-0 text-[11px] font-semibold uppercase tracking-[0.08em] ${isLight ? 'text-indigo-600' : 'text-indigo-400'}`}>
          Configurations
        </p>
        <h1 className={`mt-1 text-xl font-semibold ${isLight ? 'text-neutral-900' : 'text-neutral-50'}`}>
          Data Vault
        </h1>
        <p className={`mt-1.5 max-w-xl text-[13px] ${isLight ? 'text-slate-500' : 'text-neutral-400'}`}>
          Vector stores, cache, and vault repositories.
        </p>
      </header>
      <div className="px-6 py-5 space-y-5">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <PillTabs
            isLight={isLight}
            ariaLabel="Data vault sections"
            value={tab}
            items={TABS}
            onChange={setTab}
          />
          <button type="button" className={`${primaryBtn()} rounded-full`} onClick={() => setAddTick((value) => value + 1)}>
            <Plus size={14} /> {ADD_LABEL[tab]}
          </button>
        </div>
        <div className="min-w-0">
          {tab === 'vector-store' ? <DataStores isLight={isLight} requestAdd={addTick} /> : null}
          {tab === 'cache' ? <Cache isLight={isLight} requestAdd={addTick} /> : null}
          {tab === 'data-vault' ? <DataVaults isLight={isLight} requestAdd={addTick} /> : null}
        </div>
      </div>
    </div>
  );
};

export default DataVaultRouting;
